/* Cart presentation only: all quantities, prices and totals come from Shopify. */
(() => {
  if (window.gdsCartSyncLoaded) return;
  window.gdsCartSyncLoaded = true;
  const root = window.Shopify?.routes?.root || '/';
  let busy = false, timer;
  const cart = () => document.querySelector('[data-ux-cart]');
  const status = (message, error = false) => {
    const node = cart()?.querySelector('[data-ux-cart-status]');
    if (node) { node.textContent = message; node.classList.toggle('is-error', error); }
  };
  const lock = (value) => {
    const el = cart(); if (!el) return;
    el.setAttribute('aria-busy', String(value));
    el.querySelectorAll('[name="checkout"], .cart-refresh').forEach(n => n.disabled = value);
    el.querySelectorAll('[data-ux-quantity], [data-ux-minus], [data-ux-plus]').forEach(n => n.disabled = value);
  };
  const render = async (data, sectionId, note, focusId, focusControl, key) => {
    let html = data.sections?.[sectionId];
    if (!html) {
      const url = new URL(location.href); url.searchParams.set('section_id', sectionId);
      const response = await fetch(url, { headers: { Accept: 'text/html' }, cache: 'no-store' });
      if (!response.ok) throw new Error('refresh');
      html = await response.text();
    }
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ux-cart]');
    if (!next || !cart()) throw new Error('refresh');
    note = cart().querySelector('[name="note"]')?.value ?? note;
    cart().replaceWith(next);
    const noteField = next.querySelector('[name="note"]'); if (noteField) noteField.value = note;
    if (Number.isFinite(data.item_count)) document.querySelectorAll('[data-cart-count]').forEach(n => {
      n.textContent = data.item_count;
      n.closest('a')?.setAttribute('aria-label', `Panier, ${data.item_count} articles`);
    });
    if (focusId) document.getElementById(focusId)?.focus({ preventScroll: true });
    else if (focusControl) [...next.querySelectorAll('[data-line-key]')].find(n => n.dataset.lineKey === key)?.querySelector(focusControl)?.focus({ preventScroll: true });
  };
  const sync = async (input, quantity) => {
    if (busy || !cart()) return;
    clearTimeout(timer); busy = true;
    const sectionId = cart().dataset.sectionId;
    const key = input.closest('[data-line-key]').dataset.lineKey;
    const note = cart().querySelector('[name="note"]')?.value || '';
    const focusId = document.activeElement === input ? input.id : null;
    const focusControl = document.activeElement?.matches('[data-ux-plus]') ? '[data-ux-plus]' : document.activeElement?.matches('[data-ux-minus]') ? '[data-ux-minus]' : null;
    lock(true); status('Actualisation du panier…');
    try {
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: [sectionId], sections_url: location.pathname })
      });
      const data = await response.json();
      if (!response.ok) {
        const current = await fetch(root + 'cart.js', { cache: 'no-store' });
        if (!current.ok) throw new Error('refresh');
        await render(await current.json(), sectionId, note, focusId, focusControl, key);
        status(data.description || data.message || 'Cette quantité n’est pas disponible. Votre panier a été conservé.', true);
      } else {
        await render(data, sectionId, note, focusId, focusControl, key);
        const actual = data.items?.find(item => item.key === key)?.quantity || 0;
        status(actual !== quantity ? 'Quantité ajustée au stock disponible. Les montants ont été recalculés.' : 'Panier actualisé.', actual !== quantity);
      }
    } catch {
      // A request may have succeeded server-side: reload to avoid displaying guessed totals.
      status('Vérification de votre panier…');
      location.reload();
    } finally { busy = false; lock(false); }
  };
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-ux-minus], [data-ux-plus], [data-ux-remove]');
    if (!control || !control.closest('[data-ux-cart]')) return;
    event.preventDefault(); if (busy) return;
    const input = control.closest('[data-line-key]').querySelector('[data-ux-quantity]');
    const quantity = control.hasAttribute('data-ux-remove') ? 0 : Math.max(0, Number(input.value) + (control.hasAttribute('data-ux-plus') ? 1 : -1));
    input.value = quantity; sync(input, quantity);
  });
  document.addEventListener('input', event => {
    const input = event.target;
    if (!input.matches('[data-ux-quantity]')) return;
    clearTimeout(timer);
    cart().querySelectorAll('[name="checkout"], .cart-refresh, [data-ux-minus], [data-ux-plus], [data-ux-quantity]').forEach(n => { if(n !== input) n.disabled = true; });
    status('Actualisation du panier…');
    timer = setTimeout(() => {
      const quantity = Number(input.value);
      if (input.value === '' || !Number.isInteger(quantity) || quantity < 0) {
        input.value = input.closest('[data-line-key]').dataset.savedQuantity;
        status('Saisissez une quantité entière positive ou zéro pour retirer le produit.', true); lock(false); return;
      }
      sync(input, quantity);
    }, 450);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('[data-cart-form]') || !form.closest('[data-ux-cart]')) return;
    if (busy) { event.preventDefault(); return; }
    const changed = [...form.querySelectorAll('[data-ux-quantity]')].find(input => input.value !== input.closest('[data-line-key]').dataset.savedQuantity);
    if (changed) { event.preventDefault(); sync(changed, Math.max(0, Math.floor(Number(changed.value) || 0))); }
  });
})();
